<div class="add-location-dialog">
  <miq-global-selection
    [selectedPermissions]="permissionRecord"
    (advancedSearchEmitter)="openSubselection($event)"
    (addPermissionEmitter)="setUserPermissions($event)"
  >
  </miq-global-selection>

  <div class="sub-selection" *ngIf="showItems === true">
    <div class="district-dropdown">
      <miq-sub-selection
        [selectedFilter]="'shared.district' | xTranslate"
        [subSectionList]="districtsList"
        [editPermissionList]="district"
        [InputLength]="selectedMarketsCount"
        (selectedProperty)="selectedDistricts($event)"
      >
      </miq-sub-selection>
    </div>
    <div class="neighrbour-hood">
      <miq-sub-selection
        [selectedFilter]="'shared.neighborhood' | xTranslate"
        [subSectionList]="neighborhoodList"
        [editPermissionList]="neighborhood"
        [InputLength]="selectedNeighborCount"
        (selectedProperty)="selectedNeighbourhood($event)"
      >
      </miq-sub-selection>
    </div>
  </div>
  <div [formGroup]="formGroup" (ngSubmit)="addPermission()" class="confidentiality-container">
    <table aria-hidden="true">
      <thead class="export-labels">
        <tr>
          <th scope="col" l10nTranslate>
            shared.confidentiality
            <img
              [matTooltip]="'shared.confidentialityLevel' | xTranslate"
              [alt]="'shared.confidentialityLevel' | xTranslate"
              matTooltipClass="tooltip"
              class="confi-icon"
              src="assets/svg/mapinfo-icon.svg"
            />
          </th>
          <!-- Add an asterisk -->
          <th scope="col" l10nTranslate>shared.businessJustificationS <span class="required-icon">*</span></th>
        </tr>
      </thead>
      <tbody class="export-input">
        <tr>
          <th scope="col" class="confidentiality">
            <mat-form-field floatLabel="never" appearance="outline" style="width: 100%">
              <mat-select hideSingleSelectionIndicator="true" [formControl]="confidentialityFC" disableOptionCentering>
                <mat-option *ngFor="let level of confidentialityLevels" [value]="level">
                  {{ level.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <th scope="col" class="justification">
            <mat-form-field class="business-justification" appearance="outline">
              <textarea
                matInput
                autocomplete="no-autofill"
                [placeholder]="'shared.250CharactersLess' | xTranslate"
                class="text-area"
                [formControl]="businessJustification"
              >
              </textarea>
              <mat-error *ngIf="businessJustification.hasError('required')" l10nTranslate>
                shared.businessJustificationNeeded
              </mat-error>
              <mat-error *ngIf="businessJustification.hasError('maxlength')" l10nTranslate>
                shared.businessJustificationLessThanChars
              </mat-error>
            </mat-form-field>
          </th>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="type-length">
    <mat-hint>{{ businessJustification.value?.length || 0 }}/250</mat-hint>
  </div>

  <div mat-dialog-actions>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      value="submit"
      (click)="addPermission()"
      [disabled]="formGroup.invalid || invalidUserPermissions"
      l10nTranslate
    >
      <span *ngIf="permissionRecord; else addBtnTpl" l10nTranslate> shared.save</span>
      <ng-template #addBtnTpl><span> shared.sAdd</span></ng-template>
    </button>
  </div>
</div>
